import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import Container from 'ls-common-client/dist/components/Container';
import Header from '../../components/NewHeader';
import UserLogin from '../../components/UserManagement/UserLogin';
import AddABusiness from '../../components/AddABusiness';
import ReviewForm from '../../components/ReviewForm';
import { Context } from '../../context/AppContext';
import Reviews from './Reviews';

const UserReviews = () => {
  const {
    auth,
    media: { mobile },
  } = useContext(Context);

  return (
    <div>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <Container>
        <Header showSearch hideSearch={mobile} />
        <Container
          maxWidth="1300px"
          minHeight={mobile ? 'unset' : '800px'}
          margin="auto"
          width="100%"
          height="100%"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          {auth.token() ? <Reviews /> : <UserLogin type="reviews" />}
        </Container>
      </Container>
      <ReviewForm />
      <AddABusiness />
    </div>
  );
};

export default UserReviews;
